import { pgTable, uuid, text, timestamp, jsonb, index } from "drizzle-orm/pg-core";
import { relations } from "drizzle-orm";
import { organisations } from "./organisations";
import { conversations, messages } from "./chat";
export const agentEvents = pgTable("agent_events", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    conversationId: uuid("conversation_id")
        .notNull()
        .references(() => conversations.id, { onDelete: "cascade" }),
    messageId: uuid("message_id")
        .notNull()
        .references(() => messages.id, { onDelete: "cascade" }),
    eventType: text("event_type").notNull(),
    status: text("status"),
    toolName: text("tool_name"),
    payload: jsonb("payload").$type().default({}),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    lastUpdatedAt: timestamp("last_updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, table => ({
    messageIdx: index("idx_agent_events_message").on(table.messageId, table.createdAt),
    conversationIdx: index("idx_agent_events_conversation").on(table.conversationId, table.createdAt),
    companyIdx: index("idx_agent_events_company").on(table.companyId, table.createdAt),
}));
export const agentEventsRelations = relations(agentEvents, ({ one }) => ({
    company: one(organisations, {
        fields: [agentEvents.companyId],
        references: [organisations.id],
    }),
    conversation: one(conversations, {
        fields: [agentEvents.conversationId],
        references: [conversations.id],
    }),
    message: one(messages, {
        fields: [agentEvents.messageId],
        references: [messages.id],
    }),
}));
